<template>
  <div class="sn-f-col-b-s search">
    <div class="sn-f-s-0 sn-f-b-e" style="width: 100%;">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
        replace: true,
        router: $sn.getConfig('pcEntranceArea') ? '/appointment/area' : '/appointment/depart',
      }, {
        title: '搜索医生'
      }]"></sn-breadcrumb>
      <div class="sn-f-e-c sn-search">
        <input placeholder="搜索医生、科室、疾病" v-model="dynamic" @keyup.enter="regainSearchInfo();"/>
        <div class="sn-f-c-c interaction" @click="regainSearchInfo();">查询</div>
      </div>
    </div>
    <div class="sn-f-s-0 sn-f-e-c cost-blank">{{ $sn.getConfig('pcCostTitle') || '' }}</div>
    <div class="sn-f-1 search-blank">
      <div class="sn-table" v-if="!$sn.validate.empty(handleSearch)">
        <table>
          <thead>
            <tr>
              <th>姓名</th>
              <th>头像</th>
              <th>院区</th>
              <th>科室</th>
              <th>简介</th>
              <th>擅长</th>
              <th>{{ $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="doctor.areaId + doctor.deptId + doctor.docId + doctor.businessType" v-for="doctor in handleSearch">
              <td>{{ doctor.docName }}</td>
              <td>
                <sn-head-photo class="sn-f-s-0" :src="doctor.photo" :width="60" :height="80"></sn-head-photo>
              </td>
              <td>{{ appointment_mixin_formatAreaCaption(doctor) }}</td>
              <td>{{ doctor.deptName }}</td>
              <td>{{ handleSecretary(doctor.introduce) }}</td>
              <td>{{ handleSecretary(doctor.goodAt) }}</td>
              <td class="sn-pointer sn-fc-main" @click="homepage_mixin_navigateUrl('/appointment/doctor', doctor);">{{ appointmentContent }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <sn-no-data v-else></sn-no-data>
    </div>
    <div class="sn-f-s-0 sn-f-e-c pagination">
      <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
      <div>当前第&nbsp;&nbsp;<span class="sn-fc-main">{{ pageCount }}</span>&nbsp;&nbsp;页</div>
      <div class="sn-f-c-c sn-pointer pagination-interaction"
      :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(searchInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';

export default {
  mixins: [HomepageMixin, AppointmentMixin],
  data() {
    return {
      pageParams: {},
      dynamic: '',
      searchInfo: [],
      pageCount: 1,
      isResult: true
    };
  },
  computed: {
    handleSearch() {
      let handle = [];
      if (this.searchInfo.length > 0) {
        handle = this.$sn.format.group(this.searchInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      }
      return handle;
    },
    handleSecretary() {
      return (secretary) => {
        let caption = '暂无';
        if (secretary) {
          caption = secretary.length > 30 ? secretary.substring(0, 30) + '...' : secretary;
        }
        return caption;
      };
    }
  },
  watch: {
    pageCount: {
      handler: function(n, o) {
        if (n !== 1 && (n >= o || this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.searchInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.getSearchInfo();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.pageParams = this.$route.query;
    if (this.pageParams.dynamic) this.pageParams.dynamic = decodeURIComponent(this.pageParams.dynamic);
    this.dynamic = this.pageParams.dynamic || '';
    if (this.dynamic) {
      this.regainSearchInfo();
    }
  },
  methods: {
    regainSearchInfo() {
      this.searchInfo = [];
      this.pageCount = 1;
      this.isResult = true;
      this.getSearchInfo();
    },
    getSearchInfo() {
      const get = (ids) => {
        let res = [];
        return new Promise(resolve => {
          this.$sn.utils.ordinaryRequest({
            url: Swagger.getSearchDoctorInfoByCondition,
            query: {
              hosId: this.$sn.utils.getHospitalId(),
              docIds: ids
            },
            header: true
          }).then(result => {
            if (result && result.code === 0 && result.data && result.data.length > 0) res = result.data;
            resolve(res);
          });
        });
      };
      if (!this.dynamic || !this.isResult) return false;
      const repeat = this.$sn.getConfig('offlineSearchRepeatHanlde');
      const deduplicationRules = [];
      Object.keys(repeat).forEach(key => {
        if (!this.$sn.validate.empty(repeat[key])) {
          deduplicationRules.push({
            type: key,
            value: repeat[key]
          });
        }
      });
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getSearchInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          businessType: this.pageParams.businessType && this.$sn.getConfig('offlineSearchRestrictChannel') ? this.pageParams.businessType : '',
          deduplicationRules: deduplicationRules,
          hosId: this.$sn.utils.getHospitalId(),
          offline: 1,
          page: this.pageCount - 1,
          query: this.dynamic,
          size: this.perpetual.PAGINATION_SIZE,
          type: this.perpetual.SEARCH_TYPE_DOCTOR
        })
      }).then(async(result) => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          const match = result.data.find(res => res.type === this.perpetual.SEARCH_TYPE_DOCTOR);
          if (!this.$sn.validate.empty(match) && match.values && match.values.length > 0) {
            this.isResult = match.values.length === this.perpetual.PAGINATION_SIZE;
            const ids = [];
            match.values.forEach(doctor => {
              if (this.$sn.validate.empty(ids.find(res => res === doctor.docId))) ids.push(doctor.docId);
            });
            let entire = [];
            this.$sn.assembly.loading(true);
            entire = await get(ids.join(','));
            this.$sn.assembly.loading(false);
            if (entire.length > 0) {
              match.values.forEach(doctor => {
                const score = entire.find(res => res.doctorId === doctor.docId && res.deptId === doctor.deptId);
                if (!this.$sn.validate.empty(score)) {
                  doctor.docName = score.doctorName;
                  doctor.photo = score.doctorPicture;
                  doctor.deptName = score.deptName;
                  doctor.introduce = score.doctorIntroduce;
                  doctor.goodAt = score.doctorSkill;
                }
              });
            }
            this.searchInfo = this.searchInfo.concat(match.values);
          }
          else this.isResult = false;
        }
        else this.isResult = false;
      });
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.searchInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.search {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .cost-blank {
    @include fs(16);

    overflow: hidden;
    width: 100%;
    color: $red1;
    padding: 10px 20px;
  }

  &-blank {
    overflow: hidden;
    width: 100%;
    padding: 0 20px;

    .sn-table {
      th {
        border-right: 1px solid $white;

        &:last-child {
          border-right: 1px solid $border1;
        }
      }

      th,
      td {
        min-width: 100px;
      }

      ::v-deep .sn-head-photo {
        margin: auto;
      }
    }
  }

  .pagination {
    @include fs(16);

    width: 100%;
    height: 40px;
    margin: 20px 0 40px;

    &-interaction {
      height: 40px;
      color: $text6;
      border: 1px solid $border1;
      border-radius: 5px;
      padding: 0 20px;
      margin: 0 10px;

      &:last-child {
        margin-right: 20px;
      }
    }

    &-actived {
      color: $text1;

      &:hover {
        background-color: $main4;
        color: $main3;
        border: 1px solid $main3;
      }
    }
  }
}
</style>
